import React from 'react';

import { colors } from '@material-ui/core';
import { Loading } from '../../common';

export default function Diagnostics({ diagnosis = {}, diagnoseLoading, index = 0 }) {
  if (!diagnosis || diagnoseLoading) return <Loading />;
  if (Object.keys(diagnosis).length == 0) {
    return <div>No diagnosis found.</div>;
  }

  return (
    <div>
      <table>
        <tbody>
          <tr>
            <td>Apex: </td>
            <td> {diagnosis[index].apexidentifier}</td>
          </tr>
          <tr>
            <td>Curve: </td>
            <td>{diagnosis[index].curveDirection}</td>
          </tr>
          <tr>
            <td>Cobb Angel: </td>
            <td>{diagnosis[index].cobbAngle}</td>
          </tr>

          <tr>
            <td>Deg rotation: </td>
            <td>{diagnosis[index].rotationAngle}</td>
          </tr>
        </tbody>
      </table>
      <div style={{ color: colors.purpleGrey }}>Date Diagnosis&nbsp;</div>
      <div>{new Date(diagnosis[index].timestamp).toLocaleString()}</div>
    </div>
  );
}
